import { render, staticRenderFns } from "./LocationInput.vue?vue&type=template&id=56488cbe&scoped=true&"
import script from "./LocationInput.vue?vue&type=script&lang=js&"
export * from "./LocationInput.vue?vue&type=script&lang=js&"
import style0 from "./LocationInput.vue?vue&type=style&index=0&id=56488cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56488cbe",
  null
  
)

export default component.exports